import { firestoreService } from '@/data/services/firestoreService';
import { UserRemapper } from '../../remappers/user/userRemapper';
import type { UserDto } from '../../../data/dtos/user/userDto';

/**
 * GetUserByUsernameUseCase
 * 
 * Retrieves a user by username from Firestore.
 * Uses UserRemapper to transform raw Firestore data to User model.
 */
export class GetUserByUsernameUseCase {
    async execute(username: string): Promise<UserDto | null> {
        const rawUser = await firestoreService.getUserByUsername(username);

        if (!rawUser) {
            return null;
        }

        return UserRemapper.fromJson(rawUser);
    }
}

export const getUserByUsernameUseCase = new GetUserByUsernameUseCase();
